module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-盛泰荣誉png.87975351.png";